import { passwordchangeComponents } from "./passwordchange/navigationComponents";
import { secAccountComponents } from "./secaccountsdef/navigationComponents";
import { moneyAccountComponents } from "./moneyaccountdef/navigationComponents";
import { otherSettingsComponents } from "./othersettings/navigationComponents";

export const settingsComponents = [...passwordchangeComponents, ...secAccountComponents, ...moneyAccountComponents, ...otherSettingsComponents];

